export const goals = 'goals';
export const horizontal = 'horizontal';
export const label = 'label';
export const input = 'input';
export const singleselect = 'singleselect';
export const multiselect = 'multiselect';
export const Other = 'Other';
export const InterventionLogicalEntity = 'InterventionLogicalEntity';